export const LocalStorageKeys = {
  companyId: "COMPANYID",
  filter: "FILTER",
  groupId: "GROUPID",
  lastPage: "LASTPAGE",
  errorId: "ERRORID",
  latitudeFromIp: "LATITUDEFROMIP",
  longitudeFromIp: "LONGITUDEFROMIP",
  locationPromptShown: "LOCATIONPROMPTSHOWN",
  selectedGroups: "SELECTEDGROUPS",
  defaultDeviationInfo: "DEFAULTDEVINFO",
  externalObjectId: "EXTERNALOBJECTID",
};
